import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LTAutoCompleteModule } from './lt-auto-complete/lt-auto-complete.module';
import { LTDropDownModule } from './lt-dropdown/lt-dropdown.module';
import { LTMultiSelectModule } from './lt-multi-select/lt-multi-select.module';
import { LTTimePickerModule } from './lt-time-picker/lt-time-picker.module';
@NgModule({
  imports: [
    CommonModule,
    LTAutoCompleteModule,
    LTDropDownModule,
    LTMultiSelectModule,
    LTTimePickerModule,
  ],
  exports: [
    LTAutoCompleteModule,
    LTDropDownModule,
    LTMultiSelectModule,
    LTTimePickerModule,
  ],
})
export class LTInputModule { }